const XMAS_WINNERS_MODAL = {
    id: 'modalXmasWinners',
    title: 'Muchas felicidades a los ganadores del sorteo!',
    winners: [
        {
            name: 'Eliizita Yomii'
        },
        {
            name: 'Karen DC'
        },
        {
            name: 'Joelito Andrew Paredes Pasache'
        }
    ]
}

export {
    XMAS_WINNERS_MODAL
}